export default __webpack_public_path__ + "static/depEd-338bb8957a016ce0727d4248d9134d7f.png";